<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Złóż zamówienie
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <h2>Główny kierowca</h2>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.name"
                    :rules="formRules.name"
                    class="pt-0"
                    type="text"
                    label="Imię"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.surname"
                    :rules="formRules.surname"
                    class="pt-0"
                    type="text"
                    label="Nazwisko"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.address"
                    :rules="formRules.address"
                    class="pt-0"
                    type="text"
                    label="Adres"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.country"
                    :rules="formRules.country"
                    class="pt-0"
                    type="text"
                    label="Kraj zamieszkania"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.postalCode"
                    :rules="formRules.postalCode"
                    class="pt-0"
                    type="text"
                    label="Kod pocztowy"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.userCity"
                    :rules="formRules.userCity"
                    class="pt-0"
                    type="text"
                    label="Miasto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.phone"
                    :rules="formRules.phone"
                    class="pt-0"
                    type="text"
                    label="Numer kontaktowy"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.email"
                    :rules="formRules.email"
                    class="pt-0"
                    type="text"
                    label="Adres e-mail"
                ></v-text-field>
              </v-col>
            </v-row>
            <h2>Pozostałe informacje</h2>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-radio-group v-model="form.companyType">
                  <v-radio label="Osoba fizyczna" value="N"></v-radio>
                  <v-radio label="Firma" value="E"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="companyType === 'E'">
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.companyName"
                    :rules="formRules.companyName"
                    class="pt-0"
                    type="text"
                    label="Nazwa firmy"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.companyAddress"
                    :rules="formRules.companyAddress"
                    class="pt-0"
                    type="text"
                    label="Adres firmy"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="companyType === 'E'">
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.nip"
                    :rules="formRules.nip"
                    class="pt-0"
                    type="text"
                    label="NIP"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.city"
                    :rules="formRules.city"
                    class="pt-0"
                    type="text"
                    label="Miasto"
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.returnCity"
                    class="pt-0"
                    type="text"
                    label="Miasto zwrotu"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-menu
                    ref="dateFromMenu"
                    v-model="dateFromMenu"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-on="on"
                        v-model="form.dateFrom"
                        :rules="formRules.dateTo"
                        label="Data odbioru"
                        readonly
                        class="mt-0 pt-0 wastemaster-input-elevation"
                        solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form.dateFrom"
                      :min="getFormattedDate(0)"
                      :first-day-of-week="1"
                      locale="pl"
                      color="success"
                      no-title
                      scrollable
                      @change="updatePrice"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-menu
                    ref="dateToMenu"
                    v-model="dateToMenu"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-on="on"
                        v-model="form.dateTo"
                        :rules="formRules.dateTo"
                        label="Data odbioru"
                        readonly
                        class="mt-0 pt-0 wastemaster-input-elevation"
                        solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form.dateTo"
                      :min="getFormattedDate(0)"
                      :first-day-of-week="1"
                      locale="pl"
                      color="success"
                      no-title
                      scrollable
                      @change="updatePrice"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-select
                    v-model="timeFrom"
                    :rules="formRules.timeFrom"
                    label="Godzina odbioru"
                    class="mt-0 pt-0 wastemaster-input-elevation"
                    solo
                    :items="hours"
                    @change="updatePrice"
                >
                </v-select>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-select
                    v-model="timeTo"
                    :rules="formRules.timeTo"
                    label="Godzina zwrotu"
                    class="mt-0 pt-0 wastemaster-input-elevation"
                    solo
                    :items="hours"
                    @change="updatePrice"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense v-if="service.type.topCategoryId === 204">
                <v-menu
                    v-model="containerDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.containerDate"
                        readonly
                        :disabled="service.type.topCategoryId !== 204"
                        label="Kiedy postawić kontener"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form.containerDate"
                      @input="containerDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-switch
                    v-model="withInsurance"
                    class="pt-0"
                    type="text"
                    label="Pełne ubezpieczenie"
                    @change="updatePrice"
                ></v-switch>
              </v-col>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field v-if="withInsurance" v-model="manualInsurancePrice" label="Cena ubezpieczenia za dzień" hint="Pozostaw pustą aby została wyliczona automatycznie"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field v-model="manualPrice" label="Cena za dzień" hint="Pozostaw pustą aby została wyliczona automatycznie"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" md="3" align-self="start" dense>
                <v-text-field
                    v-model="form.gps"
                    class="pt-0"
                    label="GPS"
                    type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="3" align-self="start" dense>
                <v-text-field
                    v-model="form.childSeat0"
                    class="pt-0"
                    label="Fotelik 0-13kg"
                    type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="3" align-self="start" dense>
                <v-text-field
                    v-model="form.childSeat9"
                    class="pt-0"
                    label="Fotelik 9-18kg"
                    type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="3" align-self="start" dense>
                <v-text-field
                    v-model="form.childSeat18"
                    class="pt-0"
                    label="Fotelik 18-36kg"
                    type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    v-model="form.driverInfo"
                    class="pt-0"
                    label="Dodatkowe informacje"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.flightNumber"
                    class="pt-0"
                    label="Numer lotu"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-for="field in service.additionalFields" :key="field">
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-if="field.type === 'input'"
                    v-model="form[field.name]"
                    class="pt-0"
                    type="text"
                    :label="field.name"
                ></v-text-field>
                <v-select
                    v-if="field.type === 'select'"
                    v-model="form[field.name]"
                    class="pt-0"
                    type="text"
                    :label="field.name"
                    :items="field.options"
                ></v-select>
                <v-menu
                    v-if="field.type === 'datetime'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form[field.name]"
                        readonly
                        :label="field.name"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form[field.name]"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-card-actions>
              <div>
                <p><strong>Dni: </strong>
                <span v-if="dayPrice">{{ form.quantity }}</span>
                <span v-else>wybierz okres wynajmu</span>
                </p>
                <p><strong>Cena: </strong>
                  <span v-if="dayPrice">{{ formatAmount(((Number.parseFloat(this.manualPrice) ? Number.parseFloat(this.manualPrice) : dayPrice) + (this.withInsurance ? (Number.parseFloat(this.manualInsurancePrice) ? Number.parseFloat(this.manualInsurancePrice) : service.carRental.insuranceValue) : 0)) * this.form.quantity, 1) }}zł</span>
                  <span v-else>wybierz okres wynajmu</span>
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  :disabled="adding"
                  large
              >Zamów&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import formatters from "@/mixins/formatters";

export default {
  name: 'ModalNewOrder',
  props: {
    item: {},
  },
  mixins: [
    formatters,
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      service: null,
      manualInsurancePrice: 0,
      manualPrice: 0,
      supervisors: [],
      supervisor: null,
      containerDate: false,
      adding: false,
      dateFromMenu: false,
      dateToMenu: false,
      withInsurance: false,
      dayPrice: 0,
      timeFrom: '',
      timeTo: '',
      hours: [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30',
      ],
      form: {
        phone: '',
        name: '',
        surname: '',
        address: '',
        country: '',
        postalCode: '',
        userCity: '',
        email: '',
        companyName: '',
        companyAddress: '',
        nip: '',
        city: '',
        returnCity: '',
        dateFrom: '',
        dateTo: '',
        quantity: 0,
        driverInfo: '',
        flightNumber: '',
        gps: 0,
        childSeat0: 0,
        childSeat9: 0,
        childSeat18: 0,
        companyType: 'N',
      },
      formRules: {
        name: [(value) => !!value || 'Wpisz imię'],
        surname: [(value) => !!value || 'Wpisz nazwisko'],
        address: [(value) => !!value || 'Wpisz adres'],
        country: [(value) => !!value || 'Wpisz kraj zamieszkania'],
        postCode: [(value) => /^[0-9]{2}-[0-9]{3}$/.test(value) || 'Wpisz poprawny kod pocztowy'],
        userCity: [(value) => !!value || 'Wpisz miasto'],
        companyName: [(value) => !!value || 'Wpisz nazwę firmy'],
        companyAddress: [(value) => !!value || 'Wpisz adres firmy'],
        nip: [(value) => !!value || 'Wpisz NIP'],
        city: [(value) => !!value || 'Wpisz miasto'],
        dateFrom: [(value) => !!value || 'Wybierz datę odbioru'],
        dateTo: [(value) => !!value || 'Wybierz datę zwrotu'],
        timeFrom: [(value) => !!value || 'Wybierz godzinę odbioru'],
        timeTo: [(value) => !!value || 'Wybierz godzinę zwrotu'],
        containerDate: [(value) => !!value || 'Wybierz datę'],
        phone: [(value) => !!value || 'Wpisz numer telefonu'],
        email: [(value) => !!value || 'Wpisz adres e-mail'],
      },
      valid: false,
      paymentValues: [
        {value: '', text: 'Wybierz formę płatności'},
        {value: 'cash', text: 'Gotówka'},
        {value: 'transfer', text: 'Przelew'},
      ],
    }
  },
  methods: {
    open(service) {
      this.dialog = true
      this.service = service;
      this.timeFrom = '';
      this.timeTo = '';
      this.withInsurance = false;
      this.companyType = 'N';
      this.manualInsurancePrice = '';
      this.manualPrice = '';

      this.form = {
        quantity: 0,
        phone: '',
        email: '',
        postCode: '',
        city: '',
        returnCity: '',
        dateFrom: '',
        dateTo: '',
        driverInfo: '',
        flightNumber: '',
        gps: 0,
        childSeat0: 0,
        childSeat9: 0,
        childSeat18: 0,
        companyType: 'N',
      };

      this.loadSupervisors();
    },
    async loadSupervisors() {
      const supervisorsResponse = await api.get(`/api/users?role=ROLE_SUPERVISOR`);
      this.supervisors = [{id: 0, email: "Wybierz opiekuna -"}].concat(supervisorsResponse.data.items)
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate() || this.adding) {
        return
      }

      this.adding = true;

      let supervisor = typeof this.supervisor === 'object' && this.supervisor !== null ? this.supervisor.id : this.supervisor;

      if (supervisor === null) {
        supervisor = this.$store.state.user.identity.userId;
      }

      let data = this.form;

      data.dateFrom = data.dateFrom + ' ' + this.timeFrom;
      data.dateTo = data.dateTo + ' ' + this.timeTo;

      data.quantity = this.updateQuantity(data.dateFrom, data.dateTo);

      api
          .post('/api/service/' + this.service.id + '/buy',
              {
                withTransport: 1,
                addedAsAdmin: true,
                withInsurance: this.withInsurance,
                manualInsurancePrice: Number.parseFloat(this.manualInsurancePrice) ? Number.parseFloat(this.manualInsurancePrice) : null,
                manualPrice: Number.parseFloat(this.manualPrice) ? Number.parseFloat(this.manualPrice) : null,
                data: JSON.stringify(data),
              }
          )
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Zamówienie zostało złożone.',
            });
            this.$router.push({name: 'orders'})
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
            this.adding = false;
          })
    },
    getFormattedDate(minusDays) {
      const d = new Date()
      d.setDate(d.getDate() - minusDays)
      return this.formatDate(d)
    },
    formatDate(date) {
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    updateQuantity(dateFrom, dateTo) {
      if (!dateFrom || !dateTo) {
        return 1;
      }
      dateFrom = new Date(dateFrom);
      dateTo = new Date(dateTo);

      const datesDiff = dateTo - dateFrom;

      let hours = Math.ceil(Math.round(Math.abs(datesDiff)) / 36e5);
      let days = Math.round(hours / 24);

      if (hours - days * 24 >= 2) {
        days += 1;
      }

      return days;
    },
    updatePrice() {
      this.dayPrice = 0;
      if (this.form.dateFrom && this.form.dateTo && this.timeFrom && this.timeTo) {
        const dateFrom = this.form.dateFrom + ' ' + this.timeFrom;
        const dateTo = this.form.dateTo + ' ' + this.timeTo;
        this.form.quantity = this.updateQuantity(dateFrom, dateTo);

        api.get(`/api/service?id=${this.service.id}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
            .then((response) => {
              this.service = response.data.items[0];
              this.dayPrice = this.service.dayPrice;
            })
      }
    }
  },
}
</script>

<style scoped></style>
